/*
|-------------------------------------------------------------------------------
| VUEX modules/corporate_groups.js
|-------------------------------------------------------------------------------
| The Vuex data store for the corporate groups
*/

import CorporateGroupAPI from '../api/corporate_groups.js';

export const corporateGroups = {
	/*
    Defines the state being monitored for the module.
  */
	state: {
		corporateGroups: [],
		corporateGroupsLoadStatus: 0,

		corporateGroup: {},
		corporateGroupLoadStatus: 0,

		corporateGroupEdit: {},
		corporateGroupEditLoadStatus: 0,
		corporateGroupEditStatus: 0,
		corporateGroupEditText: '',

		corporateGroupAddStatus: 0,

		corporateGroupDeleteStatus: 0
	},

	/*
    Defines the actions used to retrieve the data.
  */
	actions: {
		/*
      Loads the corporate groups from the API
    */
		loadCorporateGroups({ commit }) {
			commit('setCorporateGroupsLoadStatus', 1);

			CorporateGroupAPI.getCorporateGroups()
				.then(function(response) {
					commit('setCorporateGroups', response.data);
					commit('setCorporateGroupsLoadStatus', 2);
				})
				.catch(function() {
					commit('setCorporateGroups', []);
					commit('setCorporateGroupsLoadStatus', 3);
				});
		},

		/*
      Loads an individual corporate group from the API
    */
		loadCorporateGroup({ commit }, data) {
			commit('setCorporateGroupLoadStatus', 1);

			return CorporateGroupAPI.getCorporateGroup(data.id)
				.then(function(response) {
					commit('setCorporateGroup', response.data);
					commit('setCorporateGroupLoadStatus', 2);
					return response;
				})
				.catch(function(error) {
					commit('setCorporateGroup', {});
					commit('setCorporateGroupLoadStatus', 3);
					return error;
				});
		},

		/*
      Deletes an individual corporate group from the API
    */
		deleteCorporateGroup({ commit, dispatch }, id) {
			commit('setCorporateGroupDeleteStatus', 1);

			CorporateGroupAPI.deleteCorporateGroup(id)
				.then(function(response) {
					dispatch('loadCorporateGroups');
					commit('setCorporateGroup', {});
					commit('setCorporateGroupDeleteStatus', 2);
				})
				.catch(function() {
					commit('setCorporateGroupDeleteStatus', 3);
				});
		},

		/*
			Loads a corporate group to edit from the API
		*/
		loadCorporateGroupEdit({ commit }, data) {
			commit('setCorporateGroupEditLoadStatus', 1);

			CorporateGroupAPI.getCorporateGroupEdit(data.slug)
				.then(function(response) {
					commit('setCorporateGroupEdit', response.data);
					commit('setCorporateGroupEditLoadStatus', 2);
				})
				.catch(function() {
					commit('setCorporateGroupEdit', {});
					commit('setCorporateGroupEditLoadStatus', 3);
				});
		},

		/*
			Edits a corporate group
		*/
		editCorporateGroup({ commit, state, dispatch }, data) {
			commit('setCorporateGroupEditStatus', 1);
			// console.log('DATA: ' + data.industries);
			return CorporateGroupAPI.putEditCorporateGroup(data.id, data.name, data.nda, data.industry_id)
				.then(function(response) {
					commit('setCorporateGroupEditText', response.data.name + ' has been successfully updated!');
					commit('setCorporateGroupEditStatus', 2);
					console.log(response);
					return response;
				})
				.catch(function(error) {
					console.log(error);
					commit('setCorporateGroupEditStatus', 3);
					return error;
				});
		},

		/*
      Adds a new corporate group
    */
		addCorporateGroup({ commit, dispatch }, data) {
			commit('setCorporateGroupAddStatus', 1);

			return CorporateGroupAPI.postAddNewCorporateGroup(data.name, data.nda, data.industry_id)
				.then(function(response) {
					commit('setCorporateGroup', response.data);
					commit('setCorporateGroupAddStatus', 2);
					dispatch('loadCorporateGroups');
					return response;
				})
				.catch(function(error) {
					commit('setCorporateGroup', {});
					commit('setCorporateGroupAddStatus', 3);
					return error;
				});
		}
	},

	/*
    Defines the mutations used
  */
	mutations: {
		/*
      Sets the corporate groups load status
    */
		setCorporateGroupsLoadStatus(state, status) {
			state.corporateGroupsLoadStatus = status;
		},

		/*
      Sets the corporate groups
    */
		setCorporateGroups(state, corporateGroups) {
			state.corporateGroups = corporateGroups;
		},

		/*
      Set the corporate group load status
    */
		setCorporateGroupLoadStatus(state, status) {
			state.corporateGroupLoadStatus = status;
		},

		/*
      Set the corporate group
    */
		setCorporateGroup(state, corporateGroup) {
			state.corporateGroup = corporateGroup;
		},

		/*
			Sets the corporate group to be edited
		*/
		setCorporateGroupEdit(state, corporateGroup) {
			state.corporateGroupEdit = corporateGroup;
		},

		/*
			Sets the corporate group edit status
		*/
		setCorporateGroupEditStatus(state, status) {
			state.corporateGroupEditStatus = status;
		},

		/*
			Sets the corporate group delete status
		*/
		setCorporateGroupDeleteStatus(state, status) {
			state.corporateGroupDeleteStatus = status;
		},

		/*
			Sets the corporate group edit text
		*/
		setCorporateGroupEditText(state, text) {
			state.corporateGroupEditText = text;
		},

		/*
			Sets the corporate group edit load status
		*/
		setCorporateGroupEditLoadStatus(state, status) {
			state.corporateGroupEditLoadStatus = status;
		},

		/*
			Sets the corporate group's industries
		*/
		setCorporateGroupAddStatus(state, status) {
			state.corporateGroupAddStatus = status;
		}
	},

	/*
    Defines the getters used by the module
  */
	getters: {
		/*
      Returns the corporate groups load status.
    */
		getCorporateGroupsLoadStatus(state) {
			return state.corporateGroupsLoadStatus;
		},

		/*
      Returns the corporate groups delete status.
    */
		getCorporateGroupsDeleteStatus(state) {
			return state.corporateGroupsDeleteStatus;
		},

		/*
      Returns the corporate groups.
    */
		getCorporateGroups(state) {
			return state.corporateGroups;
		},

		/*
      Returns the corporate groups load status
    */
		getCorporateGroupLoadStatus(state) {
			return state.corporateGroupLoadStatus;
		},

		/*
      Returns the corporate group
    */
		getCorporateGroup(state) {
			return state.corporateGroup;
		},

		/*
			Gets the corporate group we are editing
		*/
		getCorporateGroupEdit(state) {
			return state.corporateGroupEdit;
		},

		/*
			Gets the corporate group edit status
		*/
		getCorporateGroupEditStatus(state) {
			return state.corporateGroupEditStatus;
		},

		/*
			Gets the corporate group edit text
		*/
		getCorporateGroupEditText(state) {
			return state.corporateGroupEditText;
		},

		/*
			Gets the corporate group edit load status
		*/
		getCorporateGroupEditLoadStatus(state) {
			return state.corporateGroupEditLoadStatus;
		},

		/*
			Gets the corporate group add status
		*/
		getCorporateGroupAddStatus(state) {
			return state.corporateGroupAddStatus;
		}
	}
};
